import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Subscribers() {
  const [subs, setSubs] = useState([]);
  const [count, setCount] = useState(0);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    api.get("/admin/subscribers").then(({ data }) => {
      setSubs(data.subscribers);
      setCount(data.count);
    }).catch(() => toast.error("Could not load subscribers")).finally(() => setFetched(true));
  }, []);

  const exportCsv = () => {
    const rows = [["email", "source", "created_at"], ...subs.map((s) => [s.email, s.source, s.created_at])];
    const csv = rows.map((r) => r.join(",")).join("\n");
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = "good-grief-subscribers.csv";
    a.click();
  };

  return (
    <div data-testid="subscribers-panel">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
        <span data-testid="admin-count" className="border-2 border-[#DFFF00] text-[#DFFF00] px-4 py-2 text-sm">{count} total</span>
        <button onClick={exportCsv} data-testid="admin-export-btn" className="border-2 border-[#F2EFEB] px-4 py-2 text-sm hover:bg-[#DFFF00] hover:text-[#090909] hover:border-[#DFFF00] transition-colors">Export CSV</button>
      </div>
      <div className="overflow-x-auto no-scrollbar">
        {!fetched ? (
          <p data-testid="admin-loading" className="opacity-60 py-12 text-center animate-pulse">Loading the list...</p>
        ) : subs.length === 0 ? (
          <p data-testid="admin-empty" className="opacity-60 py-12 text-center">No signups yet. Go make some grief.</p>
        ) : (
          <table className="w-full text-left text-sm border-collapse" data-testid="admin-table">
            <thead>
              <tr className="border-b-2 border-[#F2EFEB] text-[#DFFF00] uppercase text-xs tracking-widest">
                <th className="py-3 pr-4">#</th><th className="py-3 pr-4">Email</th><th className="py-3 pr-4">Source</th><th className="py-3 pr-4">Joined</th>
              </tr>
            </thead>
            <tbody>
              {subs.map((s, i) => (
                <tr key={s.email + s.source} className="border-b border-[#F2EFEB]/20 hover:bg-[#F2EFEB]/5" data-testid={`admin-row-${i}`}>
                  <td className="py-3 pr-4 opacity-50">{String(i + 1).padStart(3, "0")}</td>
                  <td className="py-3 pr-4">{s.email}</td>
                  <td className="py-3 pr-4 opacity-70">{s.source}</td>
                  <td className="py-3 pr-4 opacity-70">{new Date(s.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
